import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: '[gauge]',
  templateUrl: './gauge.component.html'
})
export class GaugeComponent {

  @Input() diameter: number = 64;
  @Input() percentage: number = 0;

  private path: string;
  private stroke = 6;

  ngOnChanges(changes: SimpleChanges) {

    this.percentage = Math.round(this.percentage) % 100;

    let centerx = this.diameter / 2;
    let centery = centerx;
    let startx = centerx;
    let starty = this.diameter - (this.stroke / 2);
    let radius = (this.diameter / 2) - (this.stroke / 2);
    let bigFlag = Math.floor(this.percentage / 50);
    let end = this.percentToCartesian(centerx, centery, radius, this.percentage);

    this.path = `M ${startx} ${starty} A ${radius} ${radius} 0 ${bigFlag} 1 ${end[0]} ${end[1]}`;
  }

  private floor = (percentage: number): number => {
    return Math.floor(percentage / 50);
  }

  private percentToCartesian = (centerx: number, centery: number, radius: number, percentage: number): [number, number] => {
    let angle = (360 * percentage / 100) - 270;
    let radians = angle * Math.PI / 180;
    return [centerx + (radius * Math.cos(radians)), centery + (radius * Math.sin(radians))];
  }

}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/gauge/gauge.component.ts